import { getLength } from 'ol/sphere';

var formatLength = drawShape => {
  var length = getLength(drawShape);
  return Math.round(length * 100) / 100 + ' m';
};

export default formatLength;